module.exports = __webpack_public_path__ + "img/emo_24.199be3fb.gif";